import type { ReactNode } from 'react';
import { BoltIcon } from './icons/BoltIcon';
import { EarthIcon } from './icons/EarthIcon';
import { FireIcon } from './icons/FireIcon';
import { FlameIcon } from './icons/FlameIcon';
import { SkullIcon } from './icons/SkullIcon';
import { WaterIcon } from './icons/WaterIcon';

interface HowToPlayItem {
  icon: ReactNode;
  title: string;
  desc: string;
}

const HOW_TO_PLAY_ITEMS: HowToPlayItem[] = [
  { icon: <EarthIcon size={16} className="text-earth-light" />, title: 'Earth beats Water; draws Water+', desc: 'Loses to Fire, Earth+ & Fire+' },
  { icon: <FireIcon size={16} className="text-fire" />, title: 'Fire beats Earth; draws Earth+', desc: 'Loses to Water, Fire+ & Water+' },
  { icon: <WaterIcon size={16} className="text-water-light" />, title: 'Water beats Fire; draws Fire+', desc: 'Loses to Earth, Earth+ & Water+' },
  { icon: <BoltIcon size={16} className="text-gold" />, title: 'Energy Management', desc: 'Basic: 10 | Enhanced: 25' },
  { icon: <FlameIcon size={16} className="text-fire" />, title: 'Enhanced Moves', desc: 'Stronger but more energy: use wisely' },
  { icon: <SkullIcon size={16} className="text-energy-low" />, title: 'Overclock', desc: '30% chance your move randomizes at low energy!' },
];

interface HowToPlaySectionProps {
  className?: string;
}

export function HowToPlaySection({ className = '' }: HowToPlaySectionProps) {
  return (
    <section className={className}>
      <div className="arena-section-label mb-3">
        How to Play
      </div>
      <div className="flex flex-col gap-3 text-xs text-text-secondary">
        {HOW_TO_PLAY_ITEMS.map((item) => (
          <div key={item.title} className="flex items-start gap-2">
            <span className="flex-shrink-0 mt-0.5">{item.icon}</span>
            <div>
              <div className="font-semibold text-text-primary">{item.title}</div>
              <div>{item.desc}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
